export default {
    SHOW_POPUP: 'SHOW_POPUP',
    HIDE_POPUP: 'HIDE_POPUP',
}